import {
    AnimationLoadingBaseController,
    IAnimationControllerConfiguration,
    ILoadingBaseController,
    Inject,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../AnimationContents';
import { remapValue } from '../Common/Utils';

export class PreloaderGameController
    extends AnimationLoadingBaseController
    implements ILoadingBaseController
{
    public $model;

    private _menuBgWidth: number = 0;
    private _menuBgHeight: number = 0;

    public constructor(@Inject private _options: any) {
        super('PreloaderGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.PRELOADER_SCREEN_JSON,
            libraryName: 'loader',
        };
    }

    protected onInitialize(): void {
        const menuBg = this.getDisplayObjectByQuery('menu_bg')[0] as any;

        this._menuBgWidth = menuBg.width;
        this._menuBgHeight = menuBg.height;
    }

    protected onResize(width: number, height: number, scale: number) {
        let sizeW = width / scale;
        let sizeH = height / scale;

        const menuBgScale = Math.max(
            sizeW / this._menuBgWidth,
            sizeH / this._menuBgHeight
        );

        this.setScaleByQuery('menu_bg', menuBgScale, menuBgScale);

        const containerScale = Math.min(sizeW / 1200, sizeH / 1000);

        this.setScaleByQuery('container', containerScale, containerScale);
    }

    public onLoadingProgress(progress: number): void {
        this.gotoAndStopByQuery(
            'container.loader_bar',
            Math.floor(remapValue(progress, 0, 1, 1, 50)),
            false
        );
    }

    public onHide(): void {}

    public onShow(): void {}
}
